import { jsx as _jsx } from "react/jsx-runtime";
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import HR from 'UIComponents/elements/HR';
import UIIcon from 'UIComponents/icon/UIIcon';
import styled, { theme } from '../../../utils/Styling';
const DROPDOWN_MENU_WIDTH = 190;
const CaretIcon = styled(UIIcon).attrs({
  name: 'down'
}).withConfig({
  displayName: "DesktopDrowndown__CaretIcon",
  componentId: "rwfo0u-0"
})(["font-size:10px;"]);
export const DropdownButton = styled.button.withConfig({
  displayName: "DesktopDrowndown__DropdownButton",
  componentId: "rwfo0u-1"
})(["padding:12px 28px;background:transparent;border:none;[data-tab-active='true'] & [data-icon-name='down']{color:", ";}&[aria-expanded='true']{background-color:", ";[data-icon-name='down']{color:", ";}}&:hover{background-color:", ";[data-icon-name='down']{color:", ";}}"], theme.colors.LORAX, theme.colors.FLAT_EARTH, theme.colors.LORAX, theme.colors.FLAT_EARTH, theme.colors.LORAX);
export const Dropdown = styled(UIDropdown).attrs(({
  className
}) => ({
  popoverProps: {
    className,
    use: 'unstyled'
  },
  caretRenderer: /*#__PURE__*/_jsx(CaretIcon, {}),
  menuWidth: DROPDOWN_MENU_WIDTH,
  placement: 'bottom',
  Button: DropdownButton
})).withConfig({
  displayName: "DesktopDrowndown__Dropdown",
  componentId: "rwfo0u-2"
})(["background-color:", ";border:0;box-shadow:0 2px 4px ", ";margin-top:-4px;margin-left:16px;"], theme.colors.FLAT_EARTH, theme.colors.SLINKY);
export const DropdownNav = styled(({
  children,
  className
}) => {
  return /*#__PURE__*/_jsx("nav", {
    className: className,
    children: children
  });
}).withConfig({
  displayName: "DesktopDrowndown__DropdownNav",
  componentId: "rwfo0u-3"
})(["background-color:", ";"], theme.colors.FLAT_EARTH);
export const DropdownLink = styled(UIRouterLink).withConfig({
  displayName: "DesktopDrowndown__DropdownLink",
  componentId: "rwfo0u-4"
})(["position:relative;color:", ";display:flex;padding:8px 12px 8px 16px;font-weight:500;font-size:13px;&:hover{color:", ";background-color:", ";text-decoration:none;}align-items:center;"], theme.colors.OLAF, theme.colors.OLAF, theme.colors.OBSIDIAN);
export const DropdownDivider = styled(({
  className
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsx(HR, {})
  });
}).withConfig({
  displayName: "DesktopDrowndown__DropdownDivider",
  componentId: "rwfo0u-5"
})(["color:", ";display:flex;align-items:center;padding:8px 12px 8px 16px;height:32px;& hr{background-color:", ";}"], theme.colors.OLAF, theme.colors.HEFFALUMP);
export const NewBadge = styled(UIBadge).attrs({
  use: 'new'
}).withConfig({
  displayName: "DesktopDrowndown__NewBadge",
  componentId: "rwfo0u-6"
})(["margin-right:-12px;border-top-left-radius:10px;border-bottom-left-radius:10px;"]);